import { Popover, Tooltip } from 'antd';
import React from 'react';

export const PopoverFixed = props => (
  <Popover
    {...props}
    getPopupContainer={() => document.querySelector('.fullscreen')}
  />
);

export const TooltipFixed = props => (
  <Tooltip
    {...props}
    getPopupContainer={() => document.querySelector('.fullscreen')}
  />
);
